document.addEventListener("DOMContentLoaded", function () {
    // ========================================
    // サイト固有の設定（ここを編集）
    // ========================================
    const CONFIG = {
        // ヘッダー要素のセレクタ
        HEADER_SELECTOR_DESKTOP: ".js--hdr", // PC
        HEADER_SELECTOR_MOBILE: ".js--hdr-logo", // タブレット以下

        // デフォルトヘッダー高さ設定
        DEFAULT_HEADER_HEIGHT: 80,
        EXTRA_MARGIN: 50,
        MOBILE_BREAKPOINT: 840,

        // URLパラメータのキー名
        ANCHOR_PARAM_KEY: "anchor-id",

        // data属性名
        ANCHOR_DATA_ATTRIBUTE: "data-anchor"
    };

    const initialAnchorId = getUrlParam(CONFIG.ANCHOR_PARAM_KEY);
    if (initialAnchorId) {
        window.addEventListener("load", function () {
            scrollToAnchor(initialAnchorId);
        });
    }

    document.querySelectorAll(`[${CONFIG.ANCHOR_DATA_ATTRIBUTE}]`).forEach(function (element) {
        element.addEventListener("click", function (event) {
            event.preventDefault();

            const anchorId = this.getAttribute(CONFIG.ANCHOR_DATA_ATTRIBUTE);
            if (!anchorId) return;

            scrollToAnchor(anchorId);
        });
    });

    /**
     * スクロール動作を決定する
     */
    function getScrollBehavior() {
        const canUseSmoothScroll = "scrollBehavior" in document.documentElement.style;
        const prefersReducedMotion = window.matchMedia &&
            window.matchMedia("(prefers-reduced-motion: reduce)").matches;

        return (!prefersReducedMotion && canUseSmoothScroll) ? "smooth" : "auto";
    }

    /**
     * ヘッダーの高さを取得して、スクロール位置の補正値として返す
     * 画面幅によって参照する要素を変更
     */
    function getHeaderHeight() {
        const width = window.innerWidth || document.documentElement.clientWidth;
        let headerElement = null;

        if (width > CONFIG.MOBILE_BREAKPOINT) {
            headerElement = document.querySelector(CONFIG.HEADER_SELECTOR_DESKTOP);
        } else {
            headerElement = document.querySelector(CONFIG.HEADER_SELECTOR_MOBILE);
        }

        if (!headerElement) {
            return CONFIG.DEFAULT_HEADER_HEIGHT + CONFIG.EXTRA_MARGIN;
        }

        return headerElement.offsetHeight + CONFIG.EXTRA_MARGIN;
    }

    /**
     * URLクエリから特定キーの値を取得する
     */
    function getUrlParam(key) {
        if (!key || typeof window === "undefined" || !window.location) {
            return null;
        }

        const searchParams = new URLSearchParams(window.location.search);
        return searchParams.get(key);
    }

    /**
     * 指定したアンカーIDの位置へ、ヘッダー高さを考慮してスクロールする
     */
    function scrollToAnchor(anchorId) {
        const safeId = sanitizeAnchorId(anchorId);
        if (!safeId) {
            console.warn("Invalid anchor ID:", anchorId);
            return;
        }

        const targetElement = document.getElementById(safeId);
        if (!targetElement) {
            console.warn("Target element not found:", safeId);
            return;
        }

        const headerHeight = getHeaderHeight();
        const rect = targetElement.getBoundingClientRect();
        const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
        const targetOffset = rect.top + currentScrollTop - headerHeight;
        const behavior = getScrollBehavior();

        try {
            window.scrollTo({
                top: targetOffset,
                behavior: behavior
            });
        } catch (error) {
            console.warn("Smooth scroll not supported, using fallback:", error);
            window.scrollTo(0, targetOffset);
        }
    }

    /**
     * アンカーIDとして妥当な文字列かチェックし、不要な空白をトリムして返す
     */
    function sanitizeAnchorId(id) {
        if (typeof id !== "string") return null;

        const trimmed = id.trim();
        if (trimmed === "") return null;

        // HTML5仕様に準拠: スペースを含まず、少なくとも1文字以上
        // より厳密にチェックする場合は、この正規表現を調整
        const isValid = /^[^\s]+$/.test(trimmed);
        if (!isValid) return null;

        return trimmed;
    }
});